import React, { useState, useEffect } from "react"
import { Offcanvas } from "react-bootstrap"
import OffcanvasDatePicker from "../OffcanvasDatePicker/OffcanvasDatePicker"

import { BeatLoader } from "react-spinners"

import dayjs from "dayjs"

const list = [
  {
    eventId: 1,
    title: "Tom - Hammond; Slidell",
    description: "KM*s and Bar Managers for PNP rollout at Sherwood 8:00 am",
    startDate: "2023-05-06 11:45 AM",
    allDay: true,
  },
  {
    eventId: 2,
    title: "C-4 Rollout Meeting Bar/KM",
    description: "Pending Transfers to accept for Applebees",
    startDate: "2023-05-06 3:15 PM",
    allDay: false,
  },
  {
    eventId: 3,
    title: "Pick N Pair Rollout Meeting",
    description: "KM*s and Bar Managers for PNP rollout at Sherwood 8:00 am",
    startDate: "2023-05-06 6:30 PM",
    allDay: false,
  },
]

const listGrouped = [
  {
    date: "Wednesday, May 10 2023",
    list,
  },
  {
    date: "Thursday, May 11 2023",
    list,
  },
]

function OffcanvasCalendar(props) {
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (props.show) {
      setIsLoading(true)
      setTimeout(() => {
        setIsLoading(false)
        // console.log("isLoading false", new Date());
      }, 500)
    }
  }, [props.show])

  return (
    <Offcanvas
      show={props.show}
      onHide={props.onClose}
      placement="end"
      className="oc-custom"
    >
      <Offcanvas.Header>
        <Offcanvas.Title>Calendar</Offcanvas.Title>
        {/* the closeButton attribute for Offcanvas.Header was difficult to change the color to white */}
        <button className="btn-close" onClick={props.onClose} aria-label="Close">×</button>
      </Offcanvas.Header>
      <Offcanvas.Body className="calendar">
        <OffcanvasDatePicker
          onDateChange={(date) => console.log("calendar date change", date)}
        />

        <>
          {isLoading && (
            <div className="placeholders mt-4">
              {Array.from({ length: 3 }).map((_, index) => (
                <div
                  key={index}
                  className="d-flex align-items-center gap-3 p-3 list-item-container"
                >
                  <div className="list-item-avatar"></div>
                  <div className="flex-grow-1">
                    <div className="list-item-title mb-2"></div>
                    <div className="list-item-subtitle"></div>
                  </div>
                  <div className="list-item-count"></div>
                </div>
              ))}
            </div>
          )}

          {!isLoading && (
            <div className="list-container mt-4">
              {listGrouped &&
                listGrouped.map((group, index) => {
                  return (
                    <div key={index} className="group-container">
                      <div className="group-title">{group.date}</div>
                      {list &&
                        list.map((item, listIndex) => {
                          return (
                            <div key={listIndex} className="list-item">
                              <div className="item-container">
                                <div className="avatar">
                                  <img
                                    className="icon"
                                    src="/img/icon-calendar.svg"
                                    alt="Food"
                                  />
                                </div>

                                <div className="title-container">
                                  <div className="title truncate-line-clamp">
                                    <span className="time">
                                      {item.allDay && <>All Day</>}
                                      {!item.allDay &&
                                        dayjs(item.startDate.toString()).format(
                                          "hh:mm A"
                                        )}
                                    </span>
                                  </div>
                                  <span className="sub-title">
                                    {item.title}
                                  </span>

                                  <div className="description truncate-line-clamp">
                                    {item.description}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )
                        })}
                    </div>
                  )
                })}
            </div>
          )}
        </>

        <img className="plus-button" src={"/img/icon-list-add.svg"} alt="Add" />
      </Offcanvas.Body>
    </Offcanvas>
  )
}

export default OffcanvasCalendar
